<template>
  <div id="app">
    <div v-if="!isLoginPage" class="flex">
      <Sidebar @toggle-sidebar="onToggleSidebar" :class="sidebarOpenStatus ? 'sidebarOpen' : 'sidebarClose'" />
      <div :class="sidebarOpenStatus ? 'bodyNarrow' : 'bodyWide'">
        <Header class="w-full" />
        <div>
          <router-view />
        </div>
      </div>
    </div>
    <div v-else>
      <router-view />
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import jwt_decode from "jwt-decode";
import Header from './components/Header/Header.vue'
import Sidebar from './components/Sidebar/Sidebar.vue'
import Privacy from './pages/Privacy/Privacy.vue';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import moment from 'moment'

export default {
  name: 'App',
  components: { Header, Sidebar, Privacy },
  data() {
    return {
      isSidebarOpen: true,
      isLoginPage: true,
      isPrivacyPage: false,
      isRegisterPage: false,
      sidebarOpenStatus: true,
      isRecoveryPage:false,
      resetToken: this.$route.params.id
    }
  },
  watch: {
    '$route': function (to, from) {
      this.checkPage()
      this.checkLoggedIn()
    }
  },
  created() {
    this.checkPage()
    this.checkLoggedIn()
    
  },
  methods: {
    checkPage() {
      let currentPath = this.$router.history.current.path
      if (currentPath == '/login' || currentPath == '/privacy' ) {
        this.isLoginPage = true
        this.isPrivacyPage = true
      }
      else if (currentPath == '/login' || currentPath == '/Register' ) {
        this.isLoginPage = true
        this.isRecoveryPage= true
      }
      else if (currentPath == '/login'|| currentPath =="/recovery/"+this.resetToken) {
        this.isLoginPage = true
        this.isRecoveryPage= true
      }
      else {
        this.isLoginPage = false
        this.isPrivacyPage = false
        this.isRegisterPage = false
        this.isRecoveryPage= false
      }
    },
    decodeHTML(html) {
      let txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value; // decoder for HTML-encoded strings.
    },
    onToggleSidebar(isSidebarOpen) {
      if (localStorage.sidebarOpen === false) {
        this.sidebarOpenStatus = false
      } else this.sidebarOpenStatus = isSidebarOpen
    },
    checkLoggedIn() {
      let currentPath = this.$router.history.current.path
      if (Object.keys(localStorage).includes('userData')) {
        let decodedToken = jwt_decode(JSON.parse(localStorage.userData).data.token);
        let tokenExpireTime = moment.unix(decodedToken.exp).format()
        let currentTime = moment().format()
        if (currentTime < tokenExpireTime) {
          let token = JSON.parse(localStorage.userData).data.token
          axios.defaults.headers.common['token'] = token
          if (currentPath == "/app" || currentPath == "/login" || currentPath == "/") {
            this.$nextTick(() => {
              this.$router.push(this.$store.state.menu[0].link)
              localStorage.setItem('selectedMenu', 0)
              console.log("sdflksdj")
            });
          }
        }
        else {
        if ((currentPath != "/login") && (currentPath != "/Register")) {
          this.$store.dispatch("unsetMenu")
          localStorage.removeItem('selectedMenu')
          this.$router.push("/login");
        }
      }
      }
      else {
        if ((currentPath != "/login") && (currentPath != "/Register")) {
          this.$store.dispatch("unsetMenu")
          localStorage.removeItem('selectedMenu')
          this.$router.push("/login");
        }
      }
    }
  }
}
</script>
<style lang="sass" src="./styles/Style.sass"/>
<style lang="sass" src="./styles/DataTable.sass"></style>
<style lang="sass" src="./styles/MultiSelect.sass"></style>

